// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 140px 0 120px;
  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.4;
  animation: float 20s infinite ease-in-out;
}

.orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(46, 163, 212, 0.6) 0%, transparent 70%);
  top: -200px;
  left: -200px;
  animation-delay: 0s;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(15, 76, 129, 0.5) 0%, transparent 70%);
  bottom: -150px;
  right: -150px;
  animation-delay: -7s;
}

.orb-3 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(26, 115, 184, 0.4) 0%, transparent 70%);
  top: 50%;
  right: 10%;
  animation-delay: -14s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(50px, -50px) scale(1.1);
  }
  66% {
    transform: translate(-50px, 50px) scale(0.9);
  }
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  animation: fadeInUp 0.8s ease-out;
}

.hero-badge-top {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: fadeInUp 0.8s ease-out 0.2s backwards;
}

.hero-badge-top svg {
  color: #FFD700;
}

.hero-title {
  font-size: 68px;
  font-weight: 600;
  line-height: 1.15;
  color: white;
  margin-bottom: 32px;
  letter-spacing: -1.5px;
  animation: fadeInUp 0.8s ease-out 0.3s backwards;
}

.hero-title .highlight {
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

.hero-description {
  font-size: 20px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 48px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  animation: fadeInUp 0.8s ease-out 0.4s backwards;
}

.hero-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 80px;
  flex-wrap: wrap;
  animation: fadeInUp 0.8s ease-out 0.5s backwards;
}

.btn-hero {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 18px 36px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 50px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  border: 2px solid transparent;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.btn-hero.primary {
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
  color: #0f4c81;
  border-color: transparent;
}

.btn-hero.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(255, 215, 0, 0.4);
}

.btn-hero.secondary {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
}

.btn-hero.secondary:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.2);
}

.hero-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  animation: fadeInUp 0.8s ease-out 0.6s backwards;
}

.stat-glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px 24px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.stat-glass-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.18);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.stat-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
  text-align: center;
}

.hero-bottom-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  z-index: 2;
  line-height: 0;
}

.hero-bottom-wave svg {
  width: 100%;
  height: auto;
  display: block;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Tablet Styles */
@media (max-width: 968px) {
  .hero {
    padding: 120px 0 100px;
    min-height: 90vh;
  }

  .hero-title {
    font-size: 52px;
  }

  .hero-description {
    font-size: 18px;
    margin-bottom: 40px;
  }

  .hero-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .stat-glass-card {
    padding: 24px 16px;
  }

  .stat-icon {
    width: 56px;
    height: 56px;
  }

  .stat-icon svg {
    width: 24px;
    height: 24px;
  }

  .stat-number {
    font-size: 28px;
  }

  .stat-label {
    font-size: 12px;
  }

  .orb-1, .orb-2, .orb-3 {
    width: 400px;
    height: 400px;
  }
}

/* Mobile Styles */
@media (max-width: 640px) {
  .hero {
    padding: 100px 0 80px;
    min-height: auto;
  }

  .hero-content {
    padding: 0 16px;
  }

  .hero-badge-top {
    padding: 10px 20px;
    font-size: 12px;
    margin-bottom: 32px;
  }

  .hero-badge-top svg {
    width: 16px;
    height: 16px;
  }

  .hero-title {
    font-size: 38px;
    margin-bottom: 24px;
    letter-spacing: -1px;
  }

  .hero-description {
    font-size: 16px;
    margin-bottom: 36px;
    line-height: 1.6;
  }

  .hero-actions {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 60px;
  }

  .btn-hero {
    width: 100%;
    justify-content: center;
    padding: 16px 32px;
    font-size: 15px;
  }

  .hero-stats-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .stat-glass-card {
    flex-direction: row;
    padding: 20px;
    text-align: left;
  }

  .stat-content {
    align-items: flex-start;
  }

  .stat-icon {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
  }

  .stat-number {
    font-size: 32px;
  }

  .stat-label {
    font-size: 13px;
    text-align: left;
  }

  .orb-1, .orb-2, .orb-3 {
    width: 300px;
    height: 300px;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .hero {
    padding: 90px 0 70px;
  }

  .hero-title {
    font-size: 32px;
  }

  .hero-description {
    font-size: 15px;
  }

  .stat-number {
    font-size: 28px;
  }

  .stat-label {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,qBAAqB;EACrB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".hero {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  padding: 140px 0 120px;\n  background: linear-gradient(135deg, #0f4c81 0%, #1a73b8 50%, #2ea3d4 100%);\n}\n\n.hero-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.gradient-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.4;\n  animation: float 20s infinite ease-in-out;\n}\n\n.orb-1 {\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(46, 163, 212, 0.6) 0%, transparent 70%);\n  top: -200px;\n  left: -200px;\n  animation-delay: 0s;\n}\n\n.orb-2 {\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(15, 76, 129, 0.5) 0%, transparent 70%);\n  bottom: -150px;\n  right: -150px;\n  animation-delay: -7s;\n}\n\n.orb-3 {\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(26, 115, 184, 0.4) 0%, transparent 70%);\n  top: 50%;\n  right: 10%;\n  animation-delay: -14s;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translate(0, 0) scale(1);\n  }\n  33% {\n    transform: translate(50px, -50px) scale(1.1);\n  }\n  66% {\n    transform: translate(-50px, 50px) scale(0.9);\n  }\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.hero-badge-top {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(20px);\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 40px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  animation: fadeInUp 0.8s ease-out 0.2s backwards;\n}\n\n.hero-badge-top svg {\n  color: #FFD700;\n}\n\n.hero-title {\n  font-size: 68px;\n  font-weight: 600;\n  line-height: 1.15;\n  color: white;\n  margin-bottom: 32px;\n  letter-spacing: -1.5px;\n  animation: fadeInUp 0.8s ease-out 0.3s backwards;\n}\n\n.hero-title .highlight {\n  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 700;\n}\n\n.hero-description {\n  font-size: 20px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 48px;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n  animation: fadeInUp 0.8s ease-out 0.4s backwards;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  margin-bottom: 80px;\n  flex-wrap: wrap;\n  animation: fadeInUp 0.8s ease-out 0.5s backwards;\n}\n\n.btn-hero {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 18px 36px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 50px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  border: 2px solid transparent;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.btn-hero.primary {\n  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\n  color: #0f4c81;\n  border-color: transparent;\n}\n\n.btn-hero.primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 30px rgba(255, 215, 0, 0.4);\n}\n\n.btn-hero.secondary {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(20px);\n  color: white;\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.btn-hero.secondary:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-3px);\n  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.2);\n}\n\n.hero-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  animation: fadeInUp 0.8s ease-out 0.6s backwards;\n}\n\n.stat-glass-card {\n  background: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 32px 24px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.stat-glass-card:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.18);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.stat-number {\n  font-size: 36px;\n  font-weight: 700;\n  color: white;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.85);\n  font-weight: 500;\n  text-align: center;\n}\n\n.hero-bottom-wave {\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  line-height: 0;\n}\n\n.hero-bottom-wave svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Tablet Styles */\n@media (max-width: 968px) {\n  .hero {\n    padding: 120px 0 100px;\n    min-height: 90vh;\n  }\n\n  .hero-title {\n    font-size: 52px;\n  }\n\n  .hero-description {\n    font-size: 18px;\n    margin-bottom: 40px;\n  }\n\n  .hero-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n  }\n\n  .stat-glass-card {\n    padding: 24px 16px;\n  }\n\n  .stat-icon {\n    width: 56px;\n    height: 56px;\n  }\n\n  .stat-icon svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .stat-number {\n    font-size: 28px;\n  }\n\n  .stat-label {\n    font-size: 12px;\n  }\n\n  .orb-1, .orb-2, .orb-3 {\n    width: 400px;\n    height: 400px;\n  }\n}\n\n/* Mobile Styles */\n@media (max-width: 640px) {\n  .hero {\n    padding: 100px 0 80px;\n    min-height: auto;\n  }\n\n  .hero-content {\n    padding: 0 16px;\n  }\n\n  .hero-badge-top {\n    padding: 10px 20px;\n    font-size: 12px;\n    margin-bottom: 32px;\n  }\n\n  .hero-badge-top svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  .hero-title {\n    font-size: 38px;\n    margin-bottom: 24px;\n    letter-spacing: -1px;\n  }\n\n  .hero-description {\n    font-size: 16px;\n    margin-bottom: 36px;\n    line-height: 1.6;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 60px;\n  }\n\n  .btn-hero {\n    width: 100%;\n    justify-content: center;\n    padding: 16px 32px;\n    font-size: 15px;\n  }\n\n  .hero-stats-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .stat-glass-card {\n    flex-direction: row;\n    padding: 20px;\n    text-align: left;\n  }\n\n  .stat-content {\n    align-items: flex-start;\n  }\n\n  .stat-icon {\n    width: 56px;\n    height: 56px;\n    flex-shrink: 0;\n  }\n\n  .stat-number {\n    font-size: 32px;\n  }\n\n  .stat-label {\n    font-size: 13px;\n    text-align: left;\n  }\n\n  .orb-1, .orb-2, .orb-3 {\n    width: 300px;\n    height: 300px;\n  }\n}\n\n/* Small Mobile */\n@media (max-width: 480px) {\n  .hero {\n    padding: 90px 0 70px;\n  }\n\n  .hero-title {\n    font-size: 32px;\n  }\n\n  .hero-description {\n    font-size: 15px;\n  }\n\n  .stat-number {\n    font-size: 28px;\n  }\n\n  .stat-label {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
